import { Outlet } from 'react-router-dom';

import { Container, Flex } from '@/lib/v2/components';

const CampaignsLayout = () => {
  return (
    <Flex column>
      <div
        className="contacts-body min-h-[calc(100vh_-_64px)] w-full bg-emblueLightGray"
        id="campaigns-module"
      >
        <Container fluid="screen">
          <Outlet />
        </Container>
      </div>
    </Flex>
  );
};

export default CampaignsLayout;
